/**
 * Maps API role to Mongolian display label.
 */
export function getRoleLabel(role: string): string {
  switch (String(role).toUpperCase()) {
    case 'MANAGER':
      return 'Менежер';
    case 'WRITER':
      return 'Контент бүтээгч';
    default:
      return role;
  }
}
